var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 19,
    viewBox: "0 0 39 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94375 0.125H30.0562C34.575 0.125 38.25 4.325 38.25 9.5C38.25 14.675 34.575 18.875 30.0562 18.875H8.94375C4.425 18.875 0.75 14.675 0.75 9.5C0.75 4.325 4.425 0.125 8.94375 0.125ZM5.75625 9.29375L10.575 14.1125L18.4875 6.2L17.175 4.8875L10.575 11.4875L7.06875 7.98125L5.75625 9.29375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.361f1aabf0bc28fb8d934f5bb60ca11f.svg";
export { ForwardRef as ReactComponent };